const style = {
  form: {
    marginTop: '5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  switchContainer: {
    maxWidth: 'fit-content',
  },
};

export default style;
